<template>
           <div class="login">

    <main>
        <div class="main">
            <div class="loginform">
                <h1>太原市互联网租赁自行车考核平台</h1>
              <img src="../assets/images/p.png" class="img" alt="太原市互联网租赁自行车考核平台"/>
              <h3> 企业端</h3>
                <div class="form">
                    <p>账号</p>
                    <div class="username"><input type="text" name="username"  v-model="userName" placeholder="请输入用户名"></div>
                    <p>密码</p>
                    <div class="password"><input type="password" name="password"  v-model="passWord"  placeholder="请输入密码"></div>
<!--                  <p> 验证码</p>-->
<!--                    <div class="code"><input type="text" name="code" v-model="verifyCode" placeholder="请输入图形验证码">-->

<!--                        <span >-->
<!--                        <img :src="verifyFlagimg" @click="getVerificationCode()"/>-->
<!--                  </span>-->
<!--                    </div>-->
                    <div class="checkbox">
                        <input type="checkbox" value="true" v-model="remember">记住我
                    </div>
                  <div class="button">
                    <button type="submit" @click="changeImgCode()">
                        登录
                    </button >
                    </div>
                </div>
            </div>
        </div>
    </main>

</div>
</template>
<script>

export default ({
    name:"Login",
    data(){
      return {
                newdata:'',
                userName:'',
                passWord:'',
              //  verificationCode:'',
                verifyCode: '',
                remember:false,
                verifyFlag: '',
             //   verifyFlagimg:'',
               // imgKey:''
            }

    },
     mounted () {
            // 随机播放帧数
               // this.verifyFlag = new GVerify('v_container')

                window.setInterval(() => {
                    this.getdata()
                }, 1000)
                // this.getVerificationCode();

        },
        methods: {
            getdata(){
                var myDate = new Date();
                var year = myDate.getFullYear(); //获取当前年
                var mon = myDate.getMonth() + 1; //获取当前月
                var date = myDate.getDate(); //获取当前日
                var h = myDate.toLocaleTimeString();//获取当前小时数(0-23)前秒
                var week = myDate.getDay();
                var weeks = ["星期日", "星期一", "星期二", "星期三", "星期四", "星期五", "星期六"];
                this.newdata = year + "年" + mon + "月" + date + "日      " + weeks[week] +"      "+ h
            },

            // replace () {
            //   const num = Math.ceil(Math.random() * 10) // 生成一个随机数（防止缓存）
            //   this.verifyFlagimg = '/webapi/getVerificationCode?' + num
            // },
          //获取验证码
          //   getVerificationCode(){
          //     let that = this;
          //     this.$axios
          //       .get('/webapi/getVerificationCode')
          //       .then(function (res) {
          //        if (res.data.code == 200) {
          //          that.verifyFlagimg=res.data.data.img;
          //          that.imgKey=res.data.data.imgKey;
          //
          //        }
          //       }).catch(function (error) { // 请求失败处理
          //       console.log("服务器错误"+error);
          //     });
          //   },
            changeImgCode() {
                var that = this;

                if(that.userName == ''){
                    this.$message.error('请输入用户名');
                    // alert("请输入用户名");
                    return false;
                };
                if(that.passWord == ''){
                    this.$message.error('请输入密码');
                    // alert("请输入密码");
                    return false;
                };
                // if(that.verifyCode == ''){
                //     this.$message.error('请输入图形验证码');
                //     // alert("");
                //     return false;
                // };

                var datas = {
                    userName:that.userName,
                    passWord:that.passWord,
                    remember:that.remember,
                    //verificationCode:that.verifyCode,
                   // imgKey:that.imgKey
                };
                this.$axios.defaults.withCredentials = true;
                this.$axios
                    .post('/webapi/login', datas)
                    .then(function (res) {

                        if (res.data.code == 500) {
                            that.$message.error(res.data.msg);
                            return;
                        } else if (res.data.code == 200) {
                            that.$message({
                                message: '登录成功',
                                type: 'success'
                                });
                                window.setTimeout(() => {
                                  that.$router.push('/Index')
                                   }, 1000);
                        }
                    }).catch(function (error) { // 请求失败处理
                    console.log("服务器错误"+error);
                });
            },
        }

})
</script>

<style scoped>
     @import '../assets/css/login.css';
	#v_container{
		   width:80px;
		   height:30px!important;
		}

</style>



// WEBPACK FOOTER //
// src/view/Login.vue